query AvailableApprovalApproverList($originalUserId: UUID!) {
  availableApprovalApproverList(
    originalUserId: $originalUserId
    orderBy: NAME_ASC
  ) {
    nodes {
      id
      name
    }
  }
}
